import React, { useEffect } from 'react'
import { BiToggleLeft, BiToggleRight } from 'react-icons/bi';
import { AdsTable } from '../../../constants/adTable';
import { AiFillCaretLeft, AiFillCaretRight } from 'react-icons/ai';
import { EmptyAds } from '../../../assets/images';

type AdTableProps ={
  itemsPerPage: number; 
  setItemsPerPage: React.Dispatch<React.SetStateAction<number>>
  tableData: any;
  setTableData: React.Dispatch<React.SetStateAction<any>>;
  filterText: string;
}
const AdTable: React.FC<AdTableProps> = ({
  itemsPerPage, setItemsPerPage, setTableData, filterText, tableData}) => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const [selectedPage, setSelectedPage] = React.useState(currentPage);
  const [dropdownOptions, setDropdownOptions] = React.useState<number[]>([]);


  const totalItems = AdsTable.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);


  const [toggleSwitches, setToggleSwitches] = React.useState(Array(AdsTable.length).fill(false));


  const handleToggle = (index: any) => {
    const newToggleSwitches = [...toggleSwitches];
    newToggleSwitches[index] = !newToggleSwitches[index];
    setToggleSwitches(newToggleSwitches);
  };

    // Update the dropdown options whenever the total pages change
  React.useEffect(() => {
    const pagesArray = Array.from({ length: totalPages }, (_, index) => index + 1);
    setDropdownOptions(pagesArray);
  }, [totalPages]);

  // Handle the page selection change
  const handlePageChange = (e: any) => {
    const selectedValue = parseInt(e.target.value, 10);
    setSelectedPage(selectedValue);
    setCurrentPage(selectedValue);
  };


  useEffect(() => {
    const filteredData = AdsTable.filter((data) =>
      data.name.toLowerCase().includes(filterText.toLowerCase())
    );

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setTableData(filteredData.slice(startIndex, endIndex));

  }, [currentPage, filterText, itemsPerPage, setTableData, totalItems]);

  const startIndex = (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(currentPage * itemsPerPage, AdsTable.length);
  
  return (
    <>
      {tableData ? 
        (
          <>
            <table className='w-full text-sm mb-5 font-normal'>
              <thead className="bg-midGreen rounded-sm text-white">
                <th className='py-3 px-7 tracking-wide text-left'>Ad Name</th>
                <th className='py-3 px-7 tracking-wide text-left'>Ad Budget</th>
                <th className='py-3 px-7 tracking-wide text-left'>Delivery</th>
                <th className='py-3 px-7 tracking-wide text-left'>Bid Strategy</th>
                <th className='py-3 px-7 tracking-wide text-left'>Off/On</th>
              </thead>
              <tbody>
                {tableData.map((data: any, index: any) => (
                  <tr className="border border-[#CCC] border-solid text-[#555] border-x-0" key={index}>
                    <td className='px-7 py-6'>
                      <ul className="list-disc pl-4 marker:text-[#CCC]">
                        <li>
                          {data.name}
                        </li>
                      </ul>
                    </td>
                    <td className='px-7 py-6'>${data.price}</td>
                    <td className='px-7 py-6'>{data.stats}</td>
                    <td className='px-7 py-6'>{data.strategy}</td>
                    <td className='px-7 py-6'>
                      {
                        !toggleSwitches[index] 
                        ? <BiToggleLeft size={21} className='text-[#CCC] cursor-pointer' onClick={() => handleToggle(index)}/>
                        : <BiToggleRight size={21} className='cursor-pointer' onClick={() => handleToggle(index)}/>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="flex justify-end gap-8 text-[#555] text-xs font-Poppins items-center">
              <div className="flex justify-center items-center gap-1">
                pages: 
                <select value={selectedPage} onChange={handlePageChange} className='outline-none bg-comPagBg'>
                  {dropdownOptions.map((page) => (
                    <option key={page} value={page}>
                      {page}
                    </option>
                  ))}
                </select>    
              </div>
                         
              <label className='gap-3'>
                Items per page:{' '}
                <select value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))} className='bg-comPagBg outline-none cursor-pointer'>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
              </label>

              <p className='pt-px'>{`${startIndex} - ${endIndex} of ${AdsTable.length}`}</p>
              <div className="flex gap-3">
                <button
                  className="border rounded flex items-center justify-center w-10 h-10 shadow-sm"
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1}
                >
                  <AiFillCaretLeft size={24} />
                </button>
                <button
                  className="border rounded flex items-center justify-center w-10 h-10 shadow-sm"
                  onClick={() => setCurrentPage((prev) => prev + 1)} disabled={currentPage * itemsPerPage >= AdsTable.length}
                >
                  <AiFillCaretRight size={24} />
                </button>
              </div>
            </div>
          </>
        )
        
        :
        
        <div className="flex flex-col justify-center items-center pt-14 gap-2">
          <img src={EmptyAds} alt="" className='w-[280px]' />
          <p className=' font-Poppins text-[#000] text-base w-[320px] text-center bg-slate-100'>
            Sorry You don’t have any ad running at the moment
          </p>
        </div>
      }
    </>    
  )
}

export default AdTable;